import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface HeroProps {
  onSearch: (query: string) => void;
}

const Hero = ({ onSearch }: HeroProps) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const query = formData.get("search") as string;
    onSearch(query);
  };

  return (
    <section className="gradient-hero text-primary-foreground py-20 md:py-32 px-4">
      <div className="container mx-auto max-w-4xl text-center animate-fade-in">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          Discover Your Next Great Read
        </h1>
        <p className="text-lg md:text-xl mb-8 opacity-95">
          Browse thousands of eBooks across all genres. Read online or download for offline access.
        </p>
        
        <form onSubmit={handleSubmit} className="flex gap-2 max-w-2xl mx-auto animate-slide-up">
          <div className="relative flex-1">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
            <Input
              type="text"
              name="search"
              placeholder="Search by title, author, or category..."
              className="pl-12 h-14 text-lg bg-background/95 backdrop-blur"
            />
          </div>
          <Button type="submit" size="lg" className="h-14 px-8 bg-background text-primary hover:bg-background/90">
            Search
          </Button>
        </form>
      </div>
    </section>
  );
};

export default Hero;
